// src/pages/Requests.jsx
import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import api from "../services/api";

export default function Requests() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [repairNotes, setRepairNotes] = useState({});

  const fetchRequests = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await api.get("/requests"); // backend must return ONLY assigned requests
      setRequests(res.data || []);
    } catch (err) {
      console.error("Requests load error:", err);
      setError("Could not load requests.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  const closeRequest = async (id) => {
    const note = repairNotes[id];
    if (!note || note.trim().length === 0) {
      alert("Repair note is required");
      return;
    }

    try {
      await api.put(`/requests/${id}`, {
        status: "CLOSED",
        technician_note: note,
      });
      setRepairNotes((prev) => ({ ...prev, [id]: "" }));
      fetchRequests();
    } catch (err) {
      console.error("Close request error:", err);
      alert("Could not close request");
    }
  };

  return (
    <Layout>
      <div className="max-w-5xl mx-auto">
        <h1 className="text-2xl font-bold mb-6 text-indigo-600">
          Assigned Repair Requests
        </h1>

        {error && (
          <div className="mb-4 p-3 bg-red-50 text-red-700 rounded">
            {error}
          </div>
        )}

        <div className="bg-white rounded shadow overflow-auto">
          <table className="min-w-full text-sm">
            <thead>
              <tr className="bg-gray-100 text-left">
                <th className="px-4 py-3">Customer Name</th>
                <th className="px-4 py-3">Phone</th>
                <th className="px-4 py-3">Email</th>
                <th className="px-4 py-3">Address</th>
                <th className="px-4 py-3">Service Type</th>
                <th className="px-4 py-3">Action</th>
              </tr>
            </thead>

            <tbody>
              {requests.length === 0 && !loading && (
                <tr>
                  <td
                    colSpan={6}
                    className="p-4 text-center text-gray-500"
                  >
                    No assigned requests
                  </td>
                </tr>
              )}

              {requests.map((r) => (
                <tr key={r.id} className="border-t align-top">
                  <td className="px-4 py-3">{r.customer_name}</td>
                  <td className="px-4 py-3">{r.phone}</td>
                  <td className="px-4 py-3">{r.email}</td>
                  <td className="px-4 py-3">{r.address}</td>
                  <td className="px-4 py-3">
                    <span className="px-2 py-1 rounded text-xs bg-blue-100 text-blue-800">
                      {r.service_type}
                    </span>
                  </td>
                  <td className="px-4 py-3">
                    {r.status !== "CLOSED" ? (
                      <div className="space-y-2">
                        <textarea
                          value={repairNotes[r.id] || ""}
                          onChange={(e) =>
                            setRepairNotes({
                              ...repairNotes,
                              [r.id]: e.target.value,
                            })
                          }
                          placeholder="Enter repair work done"
                          className="w-full p-2 border rounded text-sm"
                        />

                        <button
                          onClick={() => closeRequest(r.id)}
                          className="bg-green-600 text-white px-3 py-1 rounded text-sm"
                        >
                          Close Request
                        </button>
                      </div>
                    ) : (
                      <span className="text-green-600 font-medium">
                        Closed
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {loading && (
          <div className="mt-4 text-center text-gray-500">
            Loading…
          </div>
        )}
      </div>
    </Layout>
  );
}
